export default __webpack_public_path__ + "static/media/img-4.ff280ca7.png";